"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23,3H16.5V.52A.5.5,0,0,0,16,0H8a.5.5,0,0,0-.5.5V3H1A.5.5,0,0,0,1,4H3.5v19.5A.5.5,0,0,0,4,24H20a.5.5,0,0,0,.5-.5V4H23a.5.5,0,0,0,0-1ZM8.5,18.52a.5.5,0,0,1-1,0v-11a.5.5,0,0,1,1,0ZM8.5,1h7V3h-7Zm4,17.5a.5.5,0,0,1-1,0v-11a.5.5,0,0,1,1,0Zm4,0a.5.5,0,1,1-1,0v-11a.5.5,0,0,1,1,0Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;